import { render } from "./DiffViewer.vue?vue&type=template&id=b48f7d00"
import script from "./DiffViewer.vue?vue&type=script&lang=js"
export * from "./DiffViewer.vue?vue&type=script&lang=js"

import "./DiffViewer.vue?vue&type=style&index=0&id=b48f7d00&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__